/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from './defs.defs.js'

const $nsid = 'com.atproto.admin.searchAccounts'

export { $nsid }

/** Get list of accounts that matches your search query. */
const main = l.query(
  $nsid,
  l.params({
    email: l.optional(l.string()),
    cursor: l.optional(l.string()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    accounts: l.array(
      l.ref<AdminDefs.AccountView>((() => AdminDefs.accountView) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
